import {
	Component,
	OnInit,
	Input,
	Output,
	EventEmitter,
	OnChanges,
	SimpleChanges,
	DoCheck
} from '@angular/core';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { STRING, KEYS, DTable, FILTER_TYPES, DateFilter, TableAction, TableActions } from '../../types';
import { isUndefined, isNull } from 'util';
import { Location } from '@angular/common';
const TABLE_DATA_TYPE = Object.freeze({
	ACTION: 'action',
	DEFAULT: 'default'
});
@Component({
	selector: 'app-table',
	templateUrl: './table.component.html',
	styleUrls: ['./table.component.css']
})
export class TableComponent implements OnInit, OnChanges, DoCheck {
	FILTER_TYPES = FILTER_TYPES;
	@Input() label: string;
	@Input() isBackButton: Boolean = false;
	@Input() data: any = [];
	@Input() headers: any = {};
	@Input() isResetButton = false;
	@Input() noDataMessage = 'No Data Available';
	@Input() searchFilters: any = [
			];
	clientFilters: any;
	TABLE_DATA_TYPE = TABLE_DATA_TYPE;
	@Input() fieldMapping: any = {};
	@Input()
	pagination: any = {
			count: 0,
			limit: 10
	};
	@Input() table: DTable;
	@Input() dynamicClasses: any = {};
	@Input() onClick: any = {};
	snoStart = 0;
	@Input() appliedFilter: any = {};
	@Input() filters: any = [];
	@Output() filter = new EventEmitter();
	@Output() selectFilterChange = new EventEmitter();
	@Output() pageNumberChange = new EventEmitter();
	@Output() recordsPerPageChange = new EventEmitter();
	@Input() isPaginationOnfilter = true;
	isPaginationOnfilterInside = true;
	colLabels: any = [];
	tableData: any = [];
	tableDataLength = 0;
	constructor(
		public location: Location
	) {}

	get defaultFilters() {
		return this.appliedFilter;
	}

	set defaultFilters(filter) {
		this.appliedFilter = filter;
	}

	ngOnInit() {
		if (!this.table) {
			this.table = new DTable();
			Object.assign(this.table, this);
		} else {
			Object.assign(this, this.table);
		}
		const table: any = this.table;
		table.mixedFilters = table.mixedFilters || [];
		this.table.mixedFilters = table.mixedFilters || [];
		table.onDataChange = this._formatTable.bind(this);
		this.table.mixedFilters.map(filter => {
			if (filter instanceof DateFilter) {
				filter.id = Helpers.defineCalendar(filter.startDate, filter.endDate);
			}
		});
		Object.assign(this, table);
		if (!(this.fieldMapping instanceof Object)) {
			this.fieldMapping = {};
		}
		this._formatTable();
	}

	ngDoCheck() {
		if (this.tableDataLength !== this.realData.length) {
			this._formatTable();
		}
	}

	onSearch(data) {
		console.log(data);
	}

	onKeyPress(event, [value, cb]) {
		if (this.table.clientSideSearch) {

		}
		if (cb && event.key === KEYS.ENTER && typeof cb === STRING.FUNCTION) {
			cb(value);
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes && changes.data) {
			this._formatTable();
		}
	}

	private _formatTable() {
		let colLabels = [];
		let tableData = [];
		for (const header in this.headers) {
			if (this.headers.hasOwnProperty(header)) {
				if (!this.headers[header]) {
					delete this.headers[header];
					continue;
				}
				if (this.headers[header]) {
					colLabels.push(this.headers[header]);
				}
			}
		}
		if (!colLabels.length) {
			colLabels = this._createHeaders();
		}
		tableData = this._formatTableData();
		this.colLabels = colLabels;
		this.tableData = tableData;
		this.tableDataLength = this.realData.length;
	}

	private allotClasses(dynamicClasses, header, value) {
		const classes = [];
		// const classes = ['tableTextAllign'];
		if (dynamicClasses && dynamicClasses.hasOwnProperty(header)) {
			const classValue = dynamicClasses[header];
			if ((typeof classValue === STRING.STRING) || (classValue instanceof Array)) {
				classes.push(classValue);
			} else {
				if (classValue && classValue.hasOwnProperty(value)) {
					classes.push(classValue[value]);
				}
			}
		}
		return classes;
	}

	private searchArrayOfObject(text, objects) {
		function containing(searchText, source) {
			if (source instanceof Array) {
				const allContain = source.map(data => containing(searchText, data))
										.reduce((all, current) => all && current, true);
				return allContain;
			}
			if (typeof source !== STRING.OBJECT) {
				source = source.toString().toLowerCase().trim();
				searchText = searchText.toString().toLowerCase().trim();
				return source.includes(searchText);
			}
			return false;
		}
		const result = objects.filter(obj => {
			let totalFilter = {};
			if (typeof text === STRING.OBJECT && !(text instanceof Array)) {
				totalFilter = Object.keys(text).reduce((filter, filterKey) => {
					filter[filterKey] = false;
					return filter;
				}, {})

			}
			for (const key in obj) {
				if (obj.hasOwnProperty(key)) {
					let searchText;
					if (!obj[key]) {
						continue;
					}
					if (typeof text === STRING.STRING || (text instanceof Array)) {
						searchText = text;
					} else {
						searchText = text[key]
					}
					if (isUndefined(searchText) || isNull(searchText)) {
						continue;
					}
					if (containing(searchText, obj[key])) {
						totalFilter[key] = true;
						return true;
					} else if (typeof obj[key] === STRING.OBJECT && obj[key].value) {
						if (containing(searchText, obj[key].value)) {
							totalFilter[key] = true;
							return true;
						}
					}
				}
			}
			// return Object.keys(totalFilter).reduce((allValid, filter) => (allValid && totalFilter[filter]) , true)
			return false;
		});
		return result;
		// for (const key in objects) {
		// 	if (typeof objects[key] === STRING.STRING) {

		// 	}
		// }
	}

	private allotClickEvents(onClick = {}, header: string, value: string) {
		let clickEvent;
		if (onClick && onClick.hasOwnProperty(header)) {
			const fnc = onClick[header];
			if ( typeof fnc === STRING.FUNCTION) {
				clickEvent = fnc;
			} else {
				if (fnc && fnc.hasOwnProperty(value)) {
					clickEvent = fnc;
				}
			}
		}
		return clickEvent;
	}

	private mapValue(fieldMapping = {}, header: string, value: string) {
		if (Object.keys(fieldMapping).indexOf(header) >= 0) {
			const mapping = this.fieldMapping[header];
			value = (mapping && mapping[value]) || value;
		}
		return value;
	}

	get realData() {
		return (this.table && this.table.filteredData && this.table.filteredData) || this.data;
	}

	private _formatTableData() {
		const tableData = [];
		// const data = (this.table && this.table.data && this.table.data) || this.data;
		for (const col of this.realData) {
			const newCol = [];
			for (const header in this.headers) {
				if (this.headers.hasOwnProperty(header)) {
					let value: any = col[header];
					let type: any = TABLE_DATA_TYPE.DEFAULT;
					let show: any = true;
					if (value instanceof TableActions) {
						type = TABLE_DATA_TYPE.ACTION;
						show = value.show;
						value = value.actions;
					}
					const classes = this.allotClasses(this.dynamicClasses, header, value);
					const onSelect = this.allotClickEvents(this.onClick, header, value);
					value = this.mapValue(this.fieldMapping, header, value);
					newCol.push({value, classes, onSelect, type, show, key: header});
				}
			}
			tableData.push(newCol);
		}
		return tableData;
	}

	get onlyTable() {
		return !this.label && !(this.searchFilters && this.searchFilters.length);
	}

	private _createHeaders() {
		const colLabels = [];
		if (this.data && this.data.length) {
			const colForHeader = this.data[0];
			for (const col in colForHeader) {
				if ( colForHeader.hasOwnProperty(col)) {
					const titleCaseCol = Helpers.camelToTitleCase(col);
					this.headers[col] = titleCaseCol;
					colLabels.push(titleCaseCol);
				}

			}
		}
		return colLabels;
	}

	isArray(data) {
		if (data instanceof Array) {
			return true;
		}
		return false;
	}

	doAction(index, cb) {
		if (cb && typeof cb === STRING.FUNCTION) {

			cb(this.realData[index], index);
		}
	}

	private makeClientFilterDate(appliedFilter, clientFilter) {
		const finalFilter = {};
		for (const key in clientFilter) {
			if (clientFilter.hasOwnProperty(key)) {
				const filterOn = clientFilter[key];
				filterOn.map(col => {
					finalFilter[col] = appliedFilter[key] || '';
				})
			}
		}
		const allEmpty = Object.keys(finalFilter)
							.map(filterKey => finalFilter[filterKey] === STRING.EMPTY)
								.reduce((allValue, oneValue) => allValue && oneValue, true)
		if (allEmpty) {
			return finalFilter;
		} else {
			const filteredFilter = Object.keys(finalFilter)
									.reduce((allFilter, filterName) => {
										if (finalFilter[filterName] === '') {
											return allFilter
										}
										allFilter[filterName] = finalFilter[filterName];
										return allFilter;
									}, {})
			return filteredFilter;
		}
	}

	onApplyFilter() {
		if (!this.isPaginationOnfilter) {
			this.isPaginationOnfilterInside = false;
		}
		let appliedFilter = Helpers.copyObj(this.appliedFilter);
		appliedFilter = Object.keys(appliedFilter).reduce((allFilter, filterName) => {
			if (appliedFilter[filterName] === undefined || appliedFilter[filterName] === 'undefined') {
				allFilter[filterName] = '';
			} else {
				allFilter[filterName] = appliedFilter[filterName];
			}
			return allFilter;
		}, {})
		if (this.clientFilters && Object.keys(this.clientFilters).length) {
			const filters = this.makeClientFilterDate(appliedFilter, this.clientFilters);
			const filteredData = this.searchArrayOfObject(filters, this.table.data);
			this.table.filteredData = filteredData;
			const filteredTableData = this._formatTableData();
			this.tableData = filteredTableData;
		}
		this.table.filterChanged(appliedFilter);
		this.filter.emit(appliedFilter);
	}
	onSelectFilterChangeData(event, filterName) {
		this.selectFilterChange.emit({ value: event.target.value, filterName: filterName });
	}

	onResetFilter() {
		this.appliedFilter = {};
		this.isPaginationOnfilterInside = true;
		const appliedFilter = Helpers.copyObj(this.appliedFilter);
		if (this.clientFilters && Object.keys(this.clientFilters).length) {
			const filters = this.makeClientFilterDate(appliedFilter, this.clientFilters);
			const filteredData = this.searchArrayOfObject(filters, this.table.data);
			this.table.filteredData = filteredData;
			const filteredTableData = this._formatTableData();
			this.tableData = filteredTableData;
		}
		this.table.filterChanged(appliedFilter);
		this.filter.emit(appliedFilter);
	}

	onPageNumberChange(event) {
		this.table.pagination.pageNo = event;
		this.table.paginationChanged();
		this.pageNumberChange.emit(event);
	}

	onRecordsPerPageChange(event) {
		this.table.pagination.limit = event;
		this.table.paginationChanged();
		this.recordsPerPageChange.emit(event);
	}

	get sno() {
		const pageNo = (this.table.pagination && this.table.pagination.pageNo) || 1;
		return (pageNo - 1) * (this.table.pagination.limit || 10);
	}
}

export const STATUS_CLASS = {
	INFO: 'm-badge m-badge--wide status-badge m-badge--info',
	METAL: 'm-badge m-badge--wide status-badge m-badge--metal',
	SUCCESS: 'm-badge m-badge--wide status-badge m-badge--success',
	DANGER: 'm-badge m-badge--wide status-badge m-badge--danger',
	WARNING: 'm-badge m-badge--wide status-badge m-badge--warn',
	PRIMARY: 'm-badge  m-badge--primary m-badge--wide',
	LATE: 'm-badge m-badge--wide status-badge m-badge--late',
};

export const STATUS_COLORS = {
	INFO: 'color-blue',
	SUCCESS: 'color-green',
	REJECT: 'color-red',
	PENDING: 'color-orange'
};
